<template>
  <div class="course-card" :class="colorClass">
    <div class="course-header">
      <h3>{{ title }}</h3>
    </div>
    <div class="course-content">
      <div class="course-info">
        <div class="course-time">
          <i class="fas fa-clock"></i>
          <span>{{ schedule }}</span>
        </div>
        <div class="course-description">
          {{ description }}
        </div>
      </div>
      <div class="course-image-container">
        <div class="course-image" v-if="image">
          <img :src="require(`@/assets/${image}`)" :alt="title">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CourseCard',
  props: {
    title: {
      type: String,
      required: true
    },
    schedule: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    image: {
      type: String,
      default: ''
    },
    colorClass: {
      type: String,
      default: 'pink'
    }
  }
}
</script>

<style scoped>
.course-card {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  margin-bottom: 25px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background: white;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.course-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.course-header {
  padding: 15px 20px;
  color: white;
}

.course-card.pink .course-header {
  background-color: var(--primary-color);
}

.course-card.green .course-header {
  background-color: var(--green-color);
}

.course-card.yellow .course-header {
  background-color: var(--yellow-color);
}

.course-header h3 {
  margin: 0;
  font-size: 20px;
}

.course-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.course-info {
  min-height: 120px; /* 增加最小高度，确保所有描述区域高度一致 */
  display: flex;
  flex-direction: column;
}

.course-time {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
  color: #666;
  height: 40px; /* 固定时间区域高度 */
}

.course-time i {
  margin-right: 8px;
  margin-top: 3px;
}

.course-description {
  margin-bottom: 15px;
  line-height: 1.6;
  flex-grow: 1; /* 让描述区域占据剩余空间 */
  display: flex;
  align-items: center; /* 垂直居中文本 */
}

.course-image-container {
  margin-top: auto; /* 让图片容器始终位于底部 */
  text-align: center;
}

.course-image {
  width: 100%;
  display: flex;
  justify-content: center;
}

.course-image img {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
  max-height: 200px; /* 限制图片最大高度 */
  object-fit: contain; /* 保持图片比例 */
}

@media (max-width: 768px) {
  .course-card {
    border-radius: 15px;
    margin-bottom: 15px;
  }
  
  .course-header {
    padding: 12px 15px;
  }
  
  .course-header h3 {
    font-size: 16px;
  }
  
  .course-content {
    padding: 15px;
  }
  
  .course-info {
    min-height: 100px;
  }
  
  .course-time {
    font-size: 13px;
    height: auto;
    margin-bottom: 10px;
  }
  
  .course-description {
    font-size: 13px;
    margin-bottom: 10px;
    line-height: 1.4;
  }
  
  .course-image img {
    max-height: 150px;
  }
}
</style> 